import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { EventqDialogPopover } from '../dialog-popover/dialog-popover';
import {
  AUTO_PROCESS_CONFIRM_COPY,
  AutoProcessConfirm,
  AutoProcessConfirmMode,
} from './auto-process-popover.types';

export type { AutoProcessConfirm, AutoProcessConfirmMode } from './auto-process-popover.types';

@Component({
  selector: 'eventq-auto-process-popover',
  imports: [EventqDialogPopover],
  templateUrl: './auto-process-popover.html',
  styleUrl: './auto-process-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAutoProcessPopover {
  readonly open = input(false);
  readonly mode = input.required<AutoProcessConfirmMode>();
  readonly submitDisabled = input(false);
  readonly panelWidth = input<string | null>('420px');
  readonly cancelLabel = input('Cancel');

  readonly closed = output<void>();
  readonly confirm = output<AutoProcessConfirm>();

  readonly copy = computed(() => AUTO_PROCESS_CONFIRM_COPY[this.mode()]);

  onConfirm(): void {
    this.confirm.emit({ enabled: this.mode() === 'on' });
  }
}
